import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Eye, MapPin, Phone, Mail, Clock, ExternalLink, ChevronDown, ChevronUp, BookOpen } from "lucide-react";
import { Link } from "react-router-dom";
import { siteData, albumsData } from "../data";

const galleryImages = [
  "https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/5984a11d-cf61-427e-83ae-1d37821589a2.jpeg", // IMG_4869.jpeg
  "https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/90ca7e06-f38b-41ab-bf23-fa341078958e.jpg",  // 6X6A0791-3.jpg
  "https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/4d11d0b1-5134-4cbf-beea-5b4e23060e89.jpeg", // IMG_3973.jpeg
  "https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/1e345789-e081-4275-a052-e6174ae3bcfa.jpg",  // 6X6A2112.jpg
  "https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/e7250693-36ff-4b98-a695-08a316a8d256.jpg",  // Billede15.jpg
  "https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/66231572-a1dc-4ceb-88ed-30b18d545642.jpg",  // Billede17.jpg
  "https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/2341ba95-bbc6-4ee9-9580-ffe63f081ccb.jpg",  // stegt torsk med skilt sauce.jpg
  "https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/b505504c-bc0e-4517-ae3e-bff01f3dfbfe.jpeg", // IMG_3673.jpeg
  "https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/191fbe36-2cde-41e4-bd58-3d9773016ef2.jpg",  // banner  1.jpg
  "https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/0b1a97b8-ccd9-47ed-be62-ff8258173974.jpeg", // IMG_4115.jpeg
  "https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/20d90ee2-a3a9-4431-90da-7e628dc34d6f.jpeg", // IMG_4953.jpeg
  "https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/000274af-e1b4-48c1-9654-d607082f64d7.jpg",  // Billede18.jpg
  "https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/5e698c3f-92e9-4f91-b792-1f32e7449407.jpeg", // IMG_3052.jpeg
  "https://assets.auxodev.dk/assets/4b804bad-4524-4807-89e7-374d3df315fb/bfe8c2fe-fe37-4f91-9761-620c5ad22b72.jpeg"  // IMG_8917.jpeg
];

// Helper to get Cloudflare resized image URL
const getResizedUrl = (url, width = 600) => {
  if (!url.startsWith("https://assets.auxodev.dk/")) return url;
  return url.replace("https://assets.auxodev.dk/", `https://assets.auxodev.dk/cdn-cgi/image/width=${width},quality=80,format=auto/`);
};

const menuData = {
  smorrebrod: {
    title: "SMØRREBRØD",
    hours: "Serveres fra kl. 11:00-21:00",
    description: "Alt husets smørrebrød serveres på hjemmebagt økologisk rugbrød.",
    items: [
      {
        name: "Dagens smørrebrød",
        price: "80 kr",
        description: "Se tavle eller spørg personale."
      },
      {
        name: "Husets hønsesalat",
        price: "82 kr",
        description: "Bacon, svampe-dust, syltede sennepsfrø."
      },
      {
        name: "Roastbeef af okse",
        price: "89 kr",
        description: "Remoulade, agurkesalat, fritterede løg og peberrod."
      },
      {
        name: "Kartoffelmad (V)",
        price: "78 kr",
        description: "Bløde løg, tomat, mayo og fritterede løg."
      },
      {
        name: "Røget laks",
        price: "90 kr",
        description: "Æggestand, dildcreme og urtesalat."
      },
      {
        name: "Christianøpigen kryddersild",
        price: "85 kr",
        description: "Creme fraiche, rødløg, urter, æggeblomme og blomsterkapers."
      },
      {
        name: "Stegt rødspætte m. remo",
        price: "87 kr",
        description: "Citron, tyttebær og urter."
      },
      {
        name: "Stegt rødspætte m. rejer",
        price: "97 kr",
        description: "Mayo, rejer, citron og urter."
      }
    ]
  },
  retter: {
    title: "KOLDE OG VARME RETTER",
    hours: "Serveres fra kl. 11:00-21:00",
    items: [
      {
        name: "Husets stjerneskud",
        price: "150 kr",
        description: "Lyst brød, stegt fisk, dampet fisk, rejer, citroner, mayo og 1000 ø’er dressing."
      },
      {
        name: "Pariserbøf",
        price: "140 kr",
        description: "På franskbrød med klassisk garniture."
      },
      {
        name: "Cæsarsalat",
        price: "90 kr / 115 kr",
        description: "Med croutons, sylt og parmesan. Tilkøb fritteret kylling +40 kr"
      },
      {
        name: "Golfburger",
        price: "120 kr",
        description: "Briochebolle, oksebøf, ost, bacon, salat, sylt, tomatrelish, mayo. Tilkøb af fritter og dip +35 kr"
      },
      {
        name: "Pommes frites m. dip",
        price: "50 kr",
        description: ""
      },
      {
        name: "Dagens ret",
        price: "150 kr",
        description: "Serveres man-tor fra kl. 17:00 til udsolgt."
      },
      {
        name: "Bánh Mì",
        price: "120 kr",
        description: "Med asiatisk marineret svin, syltede grønsager og koriander. Tilkøb fritter +35 kr"
      },
      {
        name: "Friteret kylling",
        price: "155 kr",
        description: "Serveres med gochochang dressing og en marineret salat."
      },
      {
        name: "Pasta med laks",
        price: "155 kr",
        description: "Vendt med spinat, hvidvinssauce og asparges."
      },
      {
        name: "Lakse-carpaccio",
        price: "125 kr",
        description: "Serveres med franskbrød, marineret salat, dildcreme og jordskokkechips."
      }
    ]
  },
  drikke: {
    title: "DRIKKEKORT",
    hours: "Serveres hele dagen",
    items: [
      {
        name: "Sodavand 50 cl",
        price: "30 kr",
        description: "Pepsi, Pepsi Max, Faxe Kondi, Faxe Kondi 0, Faxe Kondi Pink Lemonade, Faxe Kondi Appelsin 0"
      },
      {
        name: "Vand 50 cl",
        price: "25 kr",
        description: "Egekilde alm., Egekilde danskvand"
      },
      {
        name: "Øko rabarbersaft / sodavand 25 cl",
        price: "25 kr",
        description: ""
      },
      {
        name: "Husets lemonade m/u brus – 50 cl",
        price: "45 kr",
        description: ""
      },
      {
        name: "Hyldeblomst m/u brus – 50 cl",
        price: "35 kr",
        description: ""
      },
      {
        name: "Fadøl - Royal Pilsner / Classic",
        price: "30 cl: 39 kr / 50 cl: 59 kr",
        description: ""
      },
      {
        name: "Fadøl - Royal Blanche / IPA",
        price: "30 cl: 42 kr / 50 cl: 65 kr",
        description: ""
      },
      {
        name: "Fadøl - New Castle Brown Ale",
        price: "30 cl: 42 kr / 50 cl: 65 kr",
        description: ""
      },
      {
        name: "Alkoholfri øl",
        price: "Fra 39 kr",
        description: "Anarkist Hazy IPA 0,5 % (33 cl) – 42 kr / Royal Classic 0 % (33 cl) – 39 kr / Royal Pilsner 0 % (33 cl) – 39 kr"
      },
      {
        name: "Snaps 4 cl",
        price: "40 kr",
        description: "(Spørg tjener for udvalg)"
      }
    ]
  },
  vin: {
    title: "VINKORT",
    hours: "Nøje udvalgte vine",
    items: [
      {
        name: "Hvidvin - Dach, Riesling, 2025, Tyskland",
        price: "60 kr / 275 kr",
        description: ""
      },
      {
        name: "Hvidvin - Na.Ti.Vo, Pinot Grigio, 2023, Italien",
        price: "60 kr / 275 kr",
        description: ""
      },
      {
        name: "Hvidvin - 3 Wooly Sheep, Sauvignon Blanc",
        price: "375 kr",
        description: ""
      },
      {
        name: "Hvidvin - Bestheim, Gewürztraminer, Rayon de Lune, 2020",
        price: "345 kr",
        description: ""
      },
      {
        name: "Rosévin - Montgravet, Pinot Noir Rosé, 2024, Frankrig",
        price: "60 kr / 295 kr",
        description: ""
      },
      {
        name: "Rødvin - Hillgrove Creek, Shiraz, Australien",
        price: "60 kr / 275 kr",
        description: ""
      },
      {
        name: "Rødvin - Elegance 43.06, Pinot Noir, 2024",
        price: "345 kr",
        description: ""
      },
      {
        name: "Rødvin - Rinaldi, Barbera d’Alba, 2023, Italien",
        price: "425 kr",
        description: ""
      },
      {
        name: "Dessertvine & Bobler - Raimat Cava Brut, Chardonnay, Spanien",
        price: "399 kr",
        description: ""
      },
      {
        name: "Dessertvine & Bobler - Petes Puré, Moscato, Australien",
        price: "275 kr",
        description: ""
      }
    ]
  },
  desserter_kaffe: {
    title: "DESSERTER, SØDT OG KAFFE",
    hours: "Serveres hele dagen",
    items: [
      {
        name: "Dagens kage",
        price: "45 kr",
        description: "Sælges til udsolgt."
      },
      {
        name: "Gammeldags æblekage",
        price: "60 kr",
        description: "Med rasp og flødeskum."
      },
      {
        name: "2 kugler is",
        price: "55 kr",
        description: "Is, syltede bær og sprødt."
      },
      {
        name: "Dagens kage + kaffe",
        price: "70 kr",
        description: ""
      },
      {
        name: "Baristakaffe",
        price: "39 kr",
        description: "Vælg mellem: Kaffelatte, Cappuccino, Americano, Flat White, Cortado"
      },
      {
        name: "Espresso",
        price: "Single: 20 kr / Dobbelt: 30 kr",
        description: ""
      },
      {
        name: "Te- eller filterkaffekop",
        price: "20 kr",
        description: ""
      },
      {
        name: "Te- eller filterkaffekande",
        price: "60 kr",
        description: ""
      },
      {
        name: "Varm kakao med flødeskum",
        price: "45 kr",
        description: ""
      },
      {
        name: "Irish Coffee (4 cl)",
        price: "55 kr",
        description: ""
      }
    ]
  }
};

export default function Spisehuset() {
  const [selectedImage, setSelectedImage] = useState(null);
  const [openAccordion, setOpenAccordion] = useState(null);

  const toggleAccordion = (id) => {
    setOpenAccordion(openAccordion === id ? null : id);
  };

  return (
    <div className="bg-white min-h-screen pt-20 font-sans">
      
      {/* Page Hero Section */}
      <section className="relative bg-white py-16 md:py-20 border-b border-stone-100">
        <div className="max-w-4xl mx-auto px-6 text-center flex flex-col items-center">
          <motion.span 
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-amber-700 tracking-[0.2em] text-xs uppercase font-semibold mb-3"
          >
            SPISEHUSET VÆRLØSE
          </motion.span>
          <motion.h1 
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="text-4xl md:text-5xl lg:text-6xl text-stone-900 font-serif tracking-normal mb-6"
          >
            Menukort & Info
          </motion.h1>
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="text-stone-600 text-base md:text-lg font-light max-w-3xl leading-relaxed space-y-6 text-left md:text-center"
          >
            <p>
              Spisehuset v. JJfoodsolution er et moderne spisested med et menukort, der skifter løbende med sæsonen. Vi præsenterer her vores aktuelle udvalg og specialiteter.
            </p>
            <p className="text-stone-500 text-sm md:text-base italic">
              Spisehuset i Værløse Golfklub er et populært mødested for både golfspillere og lokalbefolkningen, der ønsker at nyde god mad og en afslappet atmosfære. Vores restaurant er det ideelle sted at slappe af efter en runde golf eller bare mødes med venner og familie. Det imødekommende og servicemindede personale bidrager til den behagelige stemning, og vi arrangerer ofte events og temaaftener. Spisehuset er et socialt samlingspunkt omgivet af golfklubbens smukke natur.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-6 text-sm text-stone-600 text-left border-t border-stone-100">
              <div>
                <h3 className="font-serif font-semibold text-stone-900 mb-1">Menuen på vores restaurant</h3>
                <p className="font-light leading-relaxed">
                  Vores menu er ofte baseret på friske lokale råvarer og sæsonens bedste tilbud. Køkkenpersonalet er dygtige til at sammensætte velsmagende retter, der passer til enhver smag – fra lækre sandwiches til gourmetmåltider.
                </p>
              </div>
              <div>
                <h3 className="font-serif font-semibold text-stone-900 mb-1">Tilpassede menuer</h3>
                <p className="font-light leading-relaxed">
                  I vores restaurant i Værløse er gæsterne altid i fokus. Derfor er der altid plads til eventuelle allergener og præferencer, hvor vores kokke kan tilpasse retterne lige præcis til dig.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Information & Menu Split Grid */}
      <section className="py-12 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
            
            {/* Left Column - Menu Accordions */}
            <div className="lg:col-span-7 space-y-8">
              <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 border-b border-stone-100 pb-4">
                <div>
                  <span className="text-amber-700 tracking-[0.15em] text-xs uppercase font-semibold block mb-2">UDFORSK SMAGEN</span>
                  <h2 className="text-3xl font-serif text-stone-900">Vores Menukort</h2>
                </div>
                <a 
                  href="/_assets/spisehuset-vaerloese-4.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 px-4 py-2 bg-amber-700 hover:bg-amber-800 text-white rounded-sm text-sm font-medium transition-colors shadow-sm self-start sm:self-auto"
                >
                  <i className="fa-solid fa-file-pdf text-base" aria-hidden="true"></i>
                  Hent menukort (PDF)
                </a>
              </div>

              {/* Accordion Wrapper */}
              <div className="space-y-4">
                {Object.entries(menuData).map(([key, section]) => {
                  const isOpen = openAccordion === key;
                  return (
                    <div 
                      key={key} 
                      className="border border-stone-200 rounded-sm overflow-hidden transition-all duration-300"
                    >
                      {/* Accordion Header */}
                      <button
                        onClick={() => toggleAccordion(key)}
                        className={`w-full flex items-center justify-between p-5 text-left transition-colors ${
                          isOpen ? "bg-stone-50" : "bg-white hover:bg-stone-50/50"
                        }`}
                      >
                        <div className="flex items-center gap-4">
                          <div className="w-10 h-10 bg-amber-50 flex items-center justify-center rounded-sm shrink-0">
                            <BookOpen className="w-5 h-5 text-amber-700" />
                          </div>
                          <div>
                            <h3 className="font-serif text-lg text-stone-900 font-medium">{section.title}</h3>
                            <p className="text-xs text-stone-400 font-sans mt-0.5">{section.hours}</p>
                          </div>
                        </div>
                        <div className="text-stone-400">
                          {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                        </div>
                      </button>

                      {/* Accordion Content */}
                      <AnimatePresence initial={false}>
                        {isOpen && (
                          <motion.div
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: "auto", opacity: 1 }}
                            exit={{ height: 0, opacity: 0 }}
                            transition={{ duration: 0.3, ease: "easeInOut" }}
                            className="overflow-hidden bg-white border-t border-stone-100"
                          >
                            <div className="p-6 space-y-6">
                              {section.description && (
                                <div className="pb-4 text-stone-600 text-sm font-light italic border-b border-stone-100">
                                  {section.description}
                                </div>
                              )}
                              <div className="space-y-6 divide-y divide-stone-100">
                                {section.items.map((item, index) => (
                                  <div 
                                    key={item.name} 
                                    className={`pt-5 first:pt-0 flex flex-col sm:flex-row sm:items-start justify-between gap-2`}
                                  >
                                    <div className="space-y-1 max-w-xl">
                                      <h4 className="font-serif text-base text-stone-900 font-medium">{item.name}</h4>
                                      {item.description && (
                                        <p className="text-stone-500 text-sm leading-relaxed font-light">{item.description}</p>
                                      )}
                                    </div>
                                    <div className="font-serif text-stone-900 font-medium text-base shrink-0 sm:text-right">
                                      {item.price}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Right Column - Practical Info Cards */}
            <div className="lg:col-span-5 space-y-8">
              <div>
                <span className="text-amber-700 tracking-[0.15em] text-xs uppercase font-semibold block mb-2">PRAKTISK INFO</span>
                <h2 className="text-3xl font-serif text-stone-900">Information</h2>
              </div>

              <div className="space-y-6">
                
                {/* Card 1: Åbningstider */}
                <div className="bg-stone-50 p-6 md:p-8 border border-stone-100 rounded-sm">
                  <div className="flex items-center gap-3 mb-6 border-b border-stone-200/50 pb-4">
                    <Clock className="w-5 h-5 text-amber-700 shrink-0" />
                    <h3 className="font-serif text-xl text-stone-900 font-medium">Åbningstider</h3>
                  </div>
                  
                  <div className="space-y-3 font-sans text-sm text-stone-600">
                    <div className="flex justify-between border-b border-stone-200/30 py-2">
                      <span className="font-medium text-stone-800">Alle ugens dage</span>
                      <span>11:00 - 21:00</span>
                    </div>
                    <div className="text-xs text-stone-500 pt-1">
                      Gælder fra 1. april til 31. oktober.
                    </div>
                  </div>
                </div>

                {/* Card 2: Kontakt & Adresse */}
                <div className="bg-stone-50 p-6 md:p-8 border border-stone-100 rounded-sm">
                  <div className="flex items-center gap-3 mb-6 border-b border-stone-200/50 pb-4">
                    <MapPin className="w-5 h-5 text-amber-700 shrink-0" />
                    <h3 className="font-serif text-xl text-stone-900 font-medium">Kontakt & Adresse</h3>
                  </div>

                  <div className="space-y-4 font-sans text-sm text-stone-600">
                    <div className="flex items-start gap-3">
                      <MapPin className="w-4 h-4 text-stone-400 shrink-0 mt-0.5" />
                      <div>
                        <p className="font-medium text-stone-800">Adresse</p>
                        <p className="text-stone-500">{siteData.address}</p>
                      </div>
                    </div>
                    
                    <div className="flex items-start gap-3">
                      <Phone className="w-4 h-4 text-stone-400 shrink-0 mt-0.5" />
                      <div>
                        <p className="font-medium text-stone-800">Telefon</p>
                        <a 
                          href={`tel:${siteData.phone.replace(/\s+/g, '')}`} 
                          className="text-stone-500 hover:text-amber-700 transition-colors"
                        >
                          {siteData.phone}
                        </a>
                      </div>
                    </div>

                    <div className="flex items-start gap-3">
                      <Mail className="w-4 h-4 text-stone-400 shrink-0 mt-0.5" />
                      <div>
                        <p className="font-medium text-stone-800">E-mail</p>
                        <a 
                          href={`mailto:${siteData.email}`} 
                          className="text-stone-500 hover:text-amber-700 transition-colors break-all"
                        >
                          {siteData.email}
                        </a>
                      </div>
                    </div>

                    <div className="pt-2 text-xs text-stone-400">
                      CVR: {siteData.cvr}
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className="flex flex-col sm:flex-row gap-4 mt-8">
                    <a
                      href={`tel:${siteData.phone.replace(/\s+/g, '')}`}
                      className="flex-1 bg-stone-900 hover:bg-stone-800 text-white font-sans text-xs tracking-widest uppercase py-4 px-6 rounded-none text-center transition-colors duration-200 font-semibold"
                    >
                      BESTIL BORD
                    </a>
                    <a
                      href={siteData.smiley}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex-1 bg-white hover:bg-stone-50 border border-stone-200 text-stone-700 font-sans text-xs tracking-widest uppercase py-4 px-6 rounded-none text-center transition-colors duration-200 font-semibold flex items-center justify-center gap-2"
                    >
                      SMILEY RAPPORT <ExternalLink size={12} />
                    </a>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Photo Gallery Section */}
      <section className="py-16 md:py-24 bg-stone-50 border-t border-stone-100">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col items-center">
          <div className="text-center max-w-2xl mx-auto mb-12">
            <span className="text-amber-700 tracking-[0.2em] text-xs uppercase font-semibold">RESTAURANTEN</span>
            <h2 className="text-3xl md:text-4xl font-serif text-stone-900 mt-2">Vores Rammer</h2>
            <p className="text-stone-500 mt-4 font-light text-sm leading-relaxed">
              Tag et kig på vores hyggelige rammer og atmosfære i spisehuset.
            </p>
          </div>

          {/* Grid Structure */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 w-full">
            {galleryImages.slice(0, 12).map((img, index) => (
              <motion.div 
                key={index}
                initial={{ opacity: 0, y: 15 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: (index % 6) * 0.05 }}
                viewport={{ once: true }}
                className="relative group overflow-hidden cursor-zoom-in aspect-square rounded-sm shadow-sm"
                onClick={() => setSelectedImage(img)}
              >
                <img 
                  src={getResizedUrl(img, 400)} 
                  alt={`Spisehuset stemning ${index + 1}`} 
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" 
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
                  <Eye size={20} className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox Pop-up */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4 md:p-10"
            onClick={() => setSelectedImage(null)}
          >
            <button 
              className="absolute top-6 right-6 text-white hover:text-amber-500 transition-colors z-50"
              onClick={() => setSelectedImage(null)}
            >
              <X size={32} />
            </button>
            <motion.img 
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              src={selectedImage} 
              alt="Full size view" 
              className="max-w-full max-h-full object-contain shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            />
          </motion.div>
        )}
      </AnimatePresence>

    </div>
  );
}
